export enum SceneRayCasterObjectType{
    Mesh = "Mesh",
    GridTile = "GridHelper",
}